export default "__VITE_ASSET__e977d682__"